import { NavigateFunction } from "react-router-dom";
import { ProjectOriginationValue } from "~/ProjectForm/editProjectOrigination";
import {
  Customer,
  Employee,
  FieldOffice,
  EogAfeType,
  ProjectRequest,
  ServiceDescription,
  StateCounty,
} from "~/gql/types";
import { GroupedFolder } from "~/gql/types2";
import { EnumType } from "~/visuals/organisms/InlineEnumPicker";

export type CustomerFormData = {
  customerAddress2: string | null;
  customerFax: string | null;
  customerNotes: string | null;
  customer: Customer | null;
  customerName: string | null;
  customerState: string | null;
  customerZip: string | null;
  customerCountry: string | null;
  customerAddress1: string | null;
  customerPhone: string | null;
  customerCity: string | null;
  isInternational: boolean;
  requestNewCustomer: boolean;
  /**
   * Internal flag for the GroupCustomerForm wizard's "edit current customer"
   * mode; absent (falsy) everywhere else.
   */
  editInPlace?: boolean;
  customerAdminNotes: string | null;
  customerAttn: string | null;
};

export type ProjectRequestFormData = CustomerFormData & {
  name: string | null;
  clientContactName: string | null;
  officeCode: FieldOffice | null;
  location: StateCounty | null;
  city: string | null;
  projectManager: Employee | null;
  serviceDescription: ServiceDescription | null;
  governmentFunding: EnumType | null;
  taxableServices: boolean;
  folderType: ProjectRequestFolderType | null;
  jobsFolderRequired: boolean;
  jobsFolderDriveLetter: string | null;
  newGroupedFolderName: string | null;
  newGroupedFolderDriveLetter: string | null;
  groupedFolder: GroupedFolder | null;
  budget: number | null;
  section: string | null;
  township: string | null;
  block: string | null;
  range: string | null;
  survey: string | null;
  latitude: number | null;
  longitude: number | null;
  afe: string | null;
  eogAfeType: EogAfeType | null;
  po: string | null;
  wo: string | null;
  requisitioner: string | null;
  costCenter: string | null;
  glCode: string | null;
  contractNumber: string | null;
  coGo: string | null;
  projectInstructions: string | null;
  fieldInstructions: string | null;
  fieldMeetInfo: string | null;
  fieldContact: string | null;
  officeInstructions: string | null;
  invoiceSubmitEmail: string | null;
  invoiceContact: string | null;
  additionalComments: string | null;
  notes?: string | null;
  scope: string | null;
  certifiedPayroll: boolean;
  projectOrigination: ProjectOriginationValue | null;
};

export type ProjectFormRequestProps = {
  useReload?: () => React.DispatchWithoutAction;
  type: ProjectRequestFormType;
  projectRequest?: ProjectRequest;
  initialValues?: ProjectRequestFormData;
  navHook?: () => NavigateFunction;
  otherRequests?: ProjectRequest[];
  actions?: React.ReactChild;
  title?: string;
};

export type ProjectRequestFormType = "Create" | "Edit" | "Clone" | "Group";

export enum ProjectRequestFolderType {
  None = "None",
  Single = "Single",
  ExistingGrouped = "Existing Grouped",
  NewGrouped = "New Grouped",
}
